import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule } from '@ionic/angular';
import { SETTINGS } from '@angular/fire/compat/firestore';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { firebaseConfig } from './../environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService } from './services/auth/auth.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Globalization } from '@ionic-native/globalization/ngx';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@gisaia-team/ng-pick-datetime';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'


export function initializeApp(authService: AuthService): () => Promise<void> {
    return () => authService.init();
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        IonicModule.forRoot({
            backButtonText: '',
            mode: 'ios',
            backButtonIcon: 'arrow-back-outline',
        }),
        AppRoutingModule,
        HttpClientModule,
        AngularFireModule.initializeApp(firebaseConfig),
        TranslateModule.forRoot({
            defaultLanguage: 'es',
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        OwlDateTimeModule,
		OwlNativeDateTimeModule,

    ],
  providers: [
        {
            provide: SETTINGS,
            useValue: {
                experimentalForceLongPolling: true,
                useFetchStreams: false,
            },
        },
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AuthService],
            multi: true
        },
        AuthService,
        Globalization,
    ],
    bootstrap: [
        AppComponent
    ],
})
export class AppModule { }
